import { type Getter, type Setter } from 'jotai'
import { type Category } from '../../../types/beFiltersApi'
import { categoryFormState, getDefaultCategoryFormState } from '../state/state'
import { loaderUpdater, pageState, statusUpdater } from '../../../state/page'
import { logAppError } from '../../../helpers/logger'
import {
  checkCategoryNameAlreadyExists,
  createCategory,
  editCategory,
} from '../services/services'
import { searchCategories } from './categories'
import { notifyError, notifySuccess } from '../../../helpers/notifyToast'

export const openCategoryFormCallback = (
  _: Getter,
  set: Setter,
  category?: Category,
  callback?: (get: Getter, set: Setter, category: Category) => unknown,
): void => {
  category !== undefined
    ? set(categoryFormState, {
        ...getDefaultCategoryFormState(),
        show: true,
        Id: category.Id,
        Name: category.Name,
        title: `ID ${category.Id} - ${category.Name}`,
        callback,
      })
    : set(categoryFormState, {
        ...getDefaultCategoryFormState(),
        show: true,
        callback,
      })
}

export const closeCategoryFormCallback = (_: Getter, set: Setter): void => {
  set(categoryFormState, { ...getDefaultCategoryFormState() })
}

export const submitCategoryFormCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  set(pageState, loaderUpdater(true))
  try {
    const { Id, Name, callback } = get(categoryFormState)
    const nameAlreadyExists = await checkCategoryNameAlreadyExists(Name, Id)
    if (nameAlreadyExists) {
      notifyError('Load.FiltersCategories.ErrorUniqueCategoryName')
      set(pageState, loaderUpdater(false))
      return
    }
    const isNew = Id === undefined
    const category = isNew
      ? await createCategory(Name)
      : await editCategory({ Id, Name })
    await searchCategories(get, set)
    const successMessage = isNew
      ? 'Load.Filters.CategoryCreatedSuccess'
      : 'Load.Filters.CategoryUpdatedSuccess'
    notifySuccess(successMessage)
    if (callback !== undefined) {
      callback(get, set, category)
    }
  } catch (error: any) {
    console.error('### error', error)
    logAppError({
      Component: 'newCategoriesListPage',
      Method: 'submitCategoryFormCallback',
      appError: error,
    })
    set(pageState, statusUpdater('error'))
  }
  set(pageState, loaderUpdater(false))
  set(categoryFormState, { ...getDefaultCategoryFormState() })
}
